module.exports = {
      id: "ic-theme-light-usage",
      viewBox: "0 0 236 180",
      url: __webpack_public_path__ + "sprite-dd90e0.smartcharts.svg#ic-theme-light-usage",
      toString: function () {
        return this.url;
      }
    }